<template>
  <div
    v-if="value"
    class="viewer-container"
    style="position: fixed; z-index: 2016"
  >
    <vueCropper
      ref="cropper"
      :img="getOssPath(image)"
      original
      infoTrue
      autoCrop
      canMove
      canScale
      canMoveBox
      centerBox
    ></vueCropper>
    <div
      class="viewer-button viewer-close"
      @click="closeEditor"
    ></div>
    <div class="viewer-footer">
      <div class="viewer-toolbar">
        <ul>
          <li
            class="viewer-rotate-left viewer-hide-md-down"
            @click="rotateImage('left')"
          ></li>
          <li
            class="viewer-one-to-one viewer-hide-md-down"
            @click="saveImage"
          ></li>
          <li
            class="viewer-rotate-right viewer-hide-md-down"
            @click="rotateImage('right')"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import file from '../../mixins/file'
  import { VueCropper } from 'vue-cropper'
  import 'viewerjs/dist/viewer.css'

  export default {
    name: 'file-editor',
    mixins: [file],
    components: { VueCropper },
    props: {
      value: Boolean,
      image: String
    },
    methods: {
      rotateImage(direction) {
        if (direction === 'left') {
          this.$refs['cropper'].rotateLeft()
        } else {
          this.$refs['cropper'].rotateRight()
        }
      },
      saveImage() {
        this.$refs['cropper'].getCropData(data => {
          this.$http
            .post('https://api.yundangdang.cn/base/file/change', {
              file_name: this.image,
              file_content: data
            })
            .then(() => {
              this.closeEditor()
            })
        })
      },
      closeEditor() {
        this.$emit('input', false)
      }
    }
  }
</script>

<style>
  .vue-cropper {
    background-repeat: repeat !important;
  }
</style>
